
import { useApp } from '@/hooks/useApp'
import { ExportForm } from 'BrokerTsLib/src/containers'
import { ExportGroup } from 'BrokerTsLib/src/enums'
import { ExportWrapper } from './ExportWrapper'

export const ContractsExportForm = () => {
  const { product } = useApp()

  return <ExportWrapper>
    <ExportForm product={product!} group={ExportGroup.ListContracts} />
  </ExportWrapper>
}
